/* eslint-disable camelcase */
import { EnvConfigType, AmplifyConfigType } from './ConfigType';

// local環境の設定をこちらに追加してください。
// EnvConfigTypeの変更も必要です。

const amplifyConfig: AmplifyConfigType = {
  aws_project_region: 'ap-northeast-1',
  aws_cloud_logic_custom: [
    {
      name: 'PortalAPI',
      endpoint: 'http://localhost:3000/dev',
      region: 'ap-northeast-1',
    },
    {
      name: 'BaseAPI',
      endpoint: 'http://localhost:3090/dev',
      region: 'ap-northeast-1',
    },
  ],
};

const config: EnvConfigType = {
  env: 'local',
  amplifyConfig: amplifyConfig,
  logLevel: 'DEBUG',
  analyticsTrackingId: 'G-4Z66V2XF1G',
  inquiryFormUrl: 'about:blank',
  viewerEndpoint: '',
  lpInquiryFormUrl: 'about:blank',
  ymPublishedBibliograpyUrl: 'about:blank',
  siteDomain: 'localhost',
  adminUrl: 'http://localhost:8081',
  yomokkaUrl: 'http://localhost:8082',
  sagasokkaUrl: 'http://localhost:8083',
  mottosokkaUrl: 'http://localhost:8080',
  sso: {
    redirectPath: '/loading',
    idpConfig: {
      microsoft: {
        authorizationEndpoint: 'https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize',
        clientId: 'fbd9ca6e-419d-4c08-ad53-09296ef51c27',
        clientSecret: '', // microsoftでは使用しない
        scope: ['openid', 'profile', 'email', 'User.Read'],
      },
      google: {
        authorizationEndpoint: '', // googleでは使用しない
        clientId: '417912956025-64p1i3cu046hao2b45mn1eevjkbfm41r.apps.googleusercontent.com',
        clientSecret: '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',
        scope: ['openid', 'profile', 'email'],
      },
    },
  },
  maintenanceInfoUrl: 'http://localhost:8080/info.txt',
  maintenanceExpiryUrl: 'http://localhost:8080/expiry.txt',
};

export default config;
